import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center">
            <Icon name="Crane" size={28} color="white" />
          </div>
          <span className="text-2xl font-bold text-text-primary">CranePrice</span>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-2xl font-bold text-text-primary">Welcome Back</h1>
        <p className="text-text-secondary">
          Sign in to access your crane valuation dashboard and professional tools.
        </p>
      </div>

      {/* Trust Indicators */}
      <div className="flex items-center justify-center space-x-6 mt-6 pt-6 border-t border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Shield" size={16} className="text-success" />
          <span className="text-xs text-text-secondary">Secure Login</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={16} className="text-success" />
          <span className="text-xs text-text-secondary">24/7 Access</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Users" size={16} className="text-success" />
          <span className="text-xs text-text-secondary">Trusted by 1000+ Dealers</span>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;